/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoSbpIcon20Solid = forwardRef('LogoSbpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.503 1.52a1 1 0 0 1 .998-.002l6.396 3.654a1 1 0 0 1-.002 1.738L11.457 10l5.438 3.09a1 1 0 0 1 .002 1.738l-6.396 3.654a1 1 0 0 1-1.496-.868v-6.221l-5.511 3.131A1 1 0 0 1 2 13.654V6.346a1 1 0 0 1 1.494-.87l5.511 3.132V2.386a1 1 0 0 1 .498-.865ZM7.408 10 4 8.063v3.873L7.408 10Zm3.597 2.044 3.376 1.918-3.376 1.929v-3.847Zm0-4.088V4.11l3.376 1.93-3.376 1.917Z" })));
});
